function Parametri(parametro) {
    // importanti gli spazi nella riga seguente e l'assenza del punto e virgola, per lo script che aggiorna il numero di versione
const versione = 6

    switch (parametro) {
        case 'serverURL': return 'https://emabackend.massbroken.it/link_back_front_gestione.php'; break;
        case 'release': return "T-"+versione; break;
    }
    return "";
}

export default Parametri;